import { Dispatch, SetStateAction } from 'react';
import { DrawerContainer } from '../../../../../components/Drawer/DrawerContainer';
import { DrawerHeader } from '../../../../../components/Drawer/DrawerHeader';
import EstablishmentDetails from '../../../components/EstablishmentDetails';

type EstablishmentDrawerProps = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    title: string;
    establishment: any;
    loading: boolean;
};

const EstablishmentDrawer = ({
    open,
    setOpen,
    title,
    establishment,
    loading
}: EstablishmentDrawerProps) => (
    <DrawerContainer open={open} setOpen={setOpen}>
        <DrawerHeader onIconClick={() => setOpen(false)} text={title} />
        <EstablishmentDetails establishment={establishment} loading={loading} />
    </DrawerContainer>
);

export default EstablishmentDrawer;
